<template>
    <RegistrationAndLoginSupportSuccess></RegistrationAndLoginSupportSuccess>
</template>

<script>
    import RegistrationAndLoginSupportSuccess from "../components/RegistrationAndLoginSupportSuccess";

    export default {
        name: "registration-and-login-support-success",
        components: {
            RegistrationAndLoginSupportSuccess,
        }
    };
</script>
